import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import React from 'react';
import { EmptyContent, Loading } from '../../components/common/commons';
import { NavBar } from '../../components/navbar';
import { getEstacionamento, isAdministrador } from '../../config/auth';
import { Collection } from '../../shared/constants';
import { cellphoneMask, dangerConfirm, documentMask, goToFirebase, isNullOrEmpty, takeIfIsNotNullOrEmpty, toastDismissLoading, toastLoading } from '../../shared/utils';
import { getAllContactInfoByParkId, removeContactInfoById } from '../../store/collections/contactInfoWorker';
import { getParameterByParkId } from '../../store/collections/parameterWorker';
import { getAllTicketsByPlateAndParkId } from '../../store/collections/ticketWorker';
import { TicketAnalyticsDialog } from '../buscas/ticketSearch';

class CadastrarContatos extends React.Component {
    constructor(props) {
        super(props);
        const park = getEstacionamento()
        this.state = {
            estacionamentoId: park?.id,
            clienteId: park?.clienteId
        };
    }

    render() {
        return (
            <>
                <NavBar>
                    <CadastrarContatosBody estacionamentoId={this.state.estacionamentoId} />
                </NavBar>
            </>
        )
    }
}

class CadastrarContatosBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            state: "loading",
            estacionamentoId: props.estacionamentoId,
            isShowingContactInfoModal: false,
            isAdministrador: isAdministrador(),
            list: [],
            auxList: []
        }
    }

    componentDidMount = () => {
        this._loadParameters()
        this.load()
    }

    _loadParameters = async () => {
        const parameters = await getParameterByParkId({ estacionamentoId: this.state.estacionamentoId })
        this.setState({ parameters: parameters.parameters })
    }

    search = (e) => {
        const value = e.target.value.toUpperCase().replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "")
        if (value === "") {
            this.setState({ list: this.state.auxList })
        } else {
            const result = this.state.auxList.filter(e => e.name?.toUpperCase().includes(value) ||
                e.document?.toUpperCase().replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").includes(value) ||
                e.phone?.toUpperCase().replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").includes(value))
            this.setState({ list: result })
        }
    }

    load = async () => {
        this.setState({ state: "loading" })
        const items = await getAllContactInfoByParkId({ estacionamentoId: this.state.estacionamentoId })
        this.setState({ list: items.sort((a, b) => String(a.nome ?? "").localeCompare(String(b.nome ?? ""))) })
        this.setState({ auxList: items.sort((a, b) => String(a.nome ?? "").localeCompare(String(b.nome ?? ""))) })
        if (isNullOrEmpty(items)) {
            this.setState({ state: "empty" })
        } else {
            this.setState({ state: "fill" })
        }
    }

    onEdit = (item) => {
        this.props.onEdit(item)
    }

    onDuplicate = (item) => {
        this.props.onDuplicate(item)
    }

    onRemove = async (item) => {
        this.props.onRemove(item)
    }

    onRemove = async (item) => {
        var confirm = await dangerConfirm({ message: `Confirma mesmo a remoção deste contato?` })
        if (confirm) {
            this.setState({ items: this.state.items.filter(e => e.id !== item.id) })
            this.setState({ auxList: this.state.auxList.filter(e => e.id !== item.id) })
            await removeContactInfoById({ id: item.id })
        }
    }

    onHistory = async (item) => {
        toastLoading("Buscando histórico de acessos...")
        const tickets = await getAllTicketsByPlateAndParkId({ plate: item.plate, parkId: item.estacionamentoId })
        toastDismissLoading()
        this.setState({ tickets: tickets })
        this.setState({ showModalAccessHistory: true })
    }

    onCloseAnalyticsDialog = () => {
        this.setState({ showModalAccessHistory: false })
    }

    showDetail = (item) => {
        this.setState({
            contactInfo: item,
            isShowingContactInfoModal: true
        })
    }

    render() {
        return (
            <div className="col-lg-12 card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    Todos os contatos
                </div>
                <div className='card-body'>
                    <div className='col-lg-12'>
                        <input type="text" onChange={this.search} placeholder="Faça uma busca por nome, celular, setores ou tipos..." className="form-control" />
                    </div>
                </div>
                {
                    this.state.state === "loading" &&
                    <div className="card-body">
                        <Loading />
                    </div>
                }
                {
                    this.state.state === "empty" &&
                    <div className="card-body">
                        <EmptyContent text="Nenhum contato cadastrado" />
                    </div>
                }
                {
                    this.state.state === "fill" &&
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                {
                                    this.state.isAdministrador && <td width={10} />
                                }
                                <td className="d-none d-sm-table-cell"><strong>Nome</strong></td>
                                <td className="d-none d-sm-table-cell" align='center'><strong>Celular</strong></td>
                                <td className="d-none d-sm-table-cell" align='center'><strong>E-mail</strong></td>
                                <td className="d-none d-sm-table-cell" align='center'><strong>Desde</strong></td>
                                <td width={10} align='right' />
                            </tr>
                        </thead>
                        <tbody className='table-responsive'>
                            {
                                this.state.list.map((item, index) =>
                                    <tr key={index}>
                                        {
                                            this.state.isAdministrador &&
                                            <td className="d-none d-sm-table-cell" align='center'>
                                                <div className='btn-group'>
                                                    <Tooltip title="Firebase" placement="top">
                                                        <button type="button" onClick={() => { goToFirebase({ collection: Collection.CONTACT_INFO, id: item.id }) }} className="btn btn-warning text-white">
                                                            <i className="fas fa-database" />
                                                        </button>
                                                    </Tooltip>
                                                </div>
                                            </td>
                                        }
                                        <td>{takeIfIsNotNullOrEmpty(item.nome) ?? "-"}</td>
                                        <td align='center'>{takeIfIsNotNullOrEmpty(cellphoneMask(item.phone)) ?? "-"}</td>
                                        <td align='center'>{takeIfIsNotNullOrEmpty(item.email) ?? "-"}</td>
                                        <td align='center'>{item.createdAt ? moment(item.createdAt.seconds * 1000).format("DD/MM/YYYY [ás] HH:mm") : "-"}</td>
                                        <td>
                                            <div className="btn-group">
                                                <Tooltip role="button" title="Detalhes" placement="top">
                                                    <button type="button" onClick={() => { this.showDetail(item) }} className="btn btn-primary">
                                                        <i className="fas fa-eye" />
                                                    </button>
                                                </Tooltip>
                                                <Tooltip title="Histórico de acessos" placement="top">
                                                    <button className='btn btn-warning text-white' onClick={(e) => this.onHistory(item)}>
                                                        <QueryStatsIcon />
                                                    </button>
                                                </Tooltip>
                                                <Tooltip role="button" title="Remover" placement="top">
                                                    <button type="button" onClick={() => { this.onRemove(item) }} className="btn btn-danger">
                                                        <i className="fas fa-trash" />
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                }
                {
                    this.state.showModalAccessHistory && <TicketAnalyticsDialog
                        tickets={this.state.tickets}
                        onClose={this.onCloseAnalyticsDialog} />
                }
                {
                    this.state.isShowingContactInfoModal &&
                    <CadastrarContatosDetailModal
                        contactInfo={this.state.contactInfo}
                        onClose={() => this.setState({ isShowingContactInfoModal: false })} />
                }
            </div>
        )
    }
}

class CadastrarContatosDetailModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            contactInfo: props.contactInfo
        }
    }

    onClose = () => {
        this.props.onClose()
    }

    render() {
        return (
            <Dialog fullWidth maxWidth={"xs"} open={this.state.isOpen} onClose={this.onClose}>
                {
                    this.state.isLoading ?
                        <Loading /> :
                        <>
                            <MuiDialogTitle className='text-center'>
                                Detalhes do contato
                            </MuiDialogTitle>
                            <MuiDialogContent>
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.nome) &&
                                    <div className='mt-2'>
                                        <strong>Nome</strong> <br />
                                        <span>{this.state.contactInfo?.nome ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.phone) &&
                                    <div className='mt-2'>
                                        <strong>Celular</strong> <br />
                                        <span>{takeIfIsNotNullOrEmpty(cellphoneMask(this.state.contactInfo?.phone)) ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.email) &&
                                    <div className='mt-2'>
                                        <strong>E-mail</strong> <br />
                                        <span>{this.state.contactInfo?.email ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.document) &&
                                    <div className='mt-2'>
                                        <strong>Documento</strong> <br />
                                        <span>{documentMask(this.state.contactInfo?.document) ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.rg) &&
                                    <div className='mt-2'>
                                        <strong>RG</strong> <br />
                                        <span>{this.state.contactInfo?.rg ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.landline) &&
                                    <div className='mt-2'>
                                        <strong>Telefone</strong> <br />
                                        <span>{this.state.contactInfo?.landline ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.department) &&
                                    <div className='mt-2'>
                                        <strong>Telefone</strong> <br />
                                        <span>{this.state.contactInfo?.landline ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.note) &&
                                    <div className='mt-2'>
                                        <strong>Observação</strong> <br />
                                        <span>{this.state.contactInfo?.note ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.field1Value) &&
                                    <div className='mt-2'>
                                        <strong>{this.state.contactInfo?.field1Title}</strong> <br />
                                        <span>{this.state.contactInfo?.field1Value ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.field2Value) &&
                                    <div className='mt-2'>
                                        <strong>{this.state.contactInfo?.field2Title}</strong> <br />
                                        <span>{this.state.contactInfo?.field2Value ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.field3Value) &&
                                    <div className='mt-2'>
                                        <strong>{this.state.contactInfo?.field3Title}</strong> <br />
                                        <span>{this.state.contactInfo?.field3Value ?? "Não informado"}</span>
                                    </div>
                                }
                                {
                                    !isNullOrEmpty(this.state.contactInfo?.field4Value) &&
                                    <div className='mt-2'>
                                        <strong>{this.state.contactInfo?.field4Title}</strong> <br />
                                        <span>{this.state.contactInfo?.field4Value ?? "Não informado"}</span>
                                    </div>
                                }
                                <div className='mt-3'>
                                    <span className='mt-3'>Criação: {moment(this.state.contactInfo?.createdAt.seconds * 1000).format("DD/MM/YYYY [às] HH:mm")}</span>
                                </div>
                            </MuiDialogContent>
                            <MuiDialogActions>
                                <div className='btn-group m-3'>
                                    <button onClick={this.onClose} className='btn btn-secondary'>Fechar</button>
                                </div>
                            </MuiDialogActions>
                        </>
                }
            </Dialog>
        )
    }
}

export { CadastrarContatos, CadastrarContatosDetailModal };
